import gql from 'graphql-tag';

const queryGetUserTimecard = gql`
	query GetUserTimecard {
		getUserTimecard {
			id
			user
			in
			out
			paused {
				id
				start
				end
				reason
			}
			isOnBreak
			totalTime
			totalBreakTime
			totalPaidTime
		}
	}

`;

export default queryGetUserTimecard;